define("powergen/models/improvement",
  [],
  function() {
    "use strict";
    var Improvement;

    Improvement = DS.Model.extend({
      part: DS.belongsTo('part'),
      selectedPart: DS.belongsTo('part', {
        defaultValue: null
      }),
      isCorrect: (function() {
        return this.get('part') === this.get('selectedPart');
      }).property('part', 'selectedPart'),
      isCorrected: DS.attr('boolean', {
        defaultValue: false
      }),
      partIsSelected: (function() {
        return this.get('selectedPart') !== null;
      }).property('part', 'selectedPart'),
      position: DS.attr('point'),
      size: DS.attr('size'),
      reset: function() {
        return this.setProperties({
          'selectedPart': null,
          'isCorrected': false
        });
      },
      answer: DS.attr('string')
    });


    return Improvement;
  });